import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import ReservationSelectComponent from "./ReservationSelectComponent";
import ReservationAccordian from "./ReservationAccordian";
import companyLogo from "../../assets/company_logo.png";

export default function ReservationOverviewComponent() {
  const [selectedReservations, setSelectedReservation] = useState({});
  const [selectedTickets, setSelectedTickets] = useState({});
  const [selectedActivity, setSelectedActivity] = useState([]);

  const Reservations = [
    { id: 1, guests: [{ name: "John Doe", id: "1234" }, { name: "Mike Doe", id: "9012" }], resType: "reservation 1", startDateWithTime: "23-3-2025 02:00" },
    { id: 2, guests: [{ name: "Jane Smith", id: "4567" }, { name: "Mike Johnson", id: "6789" }], resType: "reservation 2", startDateWithTime: "23-3-2025 02:00" },
    { id: 3, guests: [{ name: "John Doe", id: "1234" }, { name: "Mike Doe", id: "9012" }], resType: "reservation 3", startDateWithTime: "23-3-2025 02:00" }
  ];

  const TicketsData = [
    { id: 1, resType: "event ticket", startDateWithTime: "20-03-2025 03:50", endDateWithTime: "20-03-2025 05:30" },
    { id: 2, resType: "Standard ticket", startDateWithTime: "20-03-2025 05:00", endDateWithTime: "20-03-2025 07:30" },
    { id: 3, resType: "event ticket", startDateWithTime: "20-03-2025 07:00", endDateWithTime: "20-03-2025 09:30" }
  ];

  const ActivityData = [
    { id: 1, resType: "Activity 1", startDateWithTime: "20-03-2025 09:00", duration: "30 mins", guests: [{ name: "John Doe", id: "1234" }, { name: "Mike Doe", id: "9012" }] },
    { id: 2, resType: "Activity 2", startDateWithTime: "20-03-2025 10:00", duration: "45 mins", guests: [{ name: "John Doe", id: "1234" }, { name: "Mike Doe", id: "9012" }] },
    { id: 3, resType: "Activity 3", startDateWithTime: "20-03-2025 11:00", duration: "60 mins", guests: [{ name: "John Doe", id: "1234" }, { name: "Mike Doe", id: "9012" }] }
  ];

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", m: 2 }}>
        <Typography  sx={{color:"grey",fontSize:'1rem'}}> Wg4232</Typography>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
        <Box sx={{ width: 200, height: 200 }}>
          <img src={companyLogo} alt="Company Logo" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
        </Box>

        <Box sx={{ maxWidth: { md: 500, sm: "90%", xs: "90%" }, width: "100%" }}>
          <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 2 }}>
            <Typography variant="h6" sx={{fontWeight:"bold"}}>Reservation Overview</Typography>
          </Box>

          <ReservationAccordian
            data={Reservations}
            value={selectedReservations}
            setValue={setSelectedReservation}
            label="Table Reservations"
            type="reservation"
            ModuleComponent={ReservationSelectComponent}
          />

          <ReservationAccordian
            data={TicketsData}
            value={selectedTickets}
            setValue={setSelectedTickets}
            label="Tickets"
            type="ticket"
            ModuleComponent={ReservationSelectComponent}
          />

          <ReservationAccordian
            data={ActivityData}
            value={selectedActivity}
            setValue={setSelectedActivity}
            label="Activity Reservations"
            type="activity"
            ModuleComponent={ReservationSelectComponent}
          />
        </Box>
      </Box>
    </>
  );
}
